import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function View({ width, height, color }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.99674 0.625C4.08008 0.625 1.58924 2.43917 0.580078 5C1.58924 7.56083 4.08008 9.375 6.99674 9.375C9.91341 9.375 12.4042 7.56083 13.4134 5C12.4042 2.43917 9.91341 0.625 6.99674 0.625ZM6.99674 7.91667C5.38674 7.91667 4.08008 6.61 4.08008 5C4.08008 3.39 5.38674 2.08333 6.99674 2.08333C8.60674 2.08333 9.91341 3.39 9.91341 5C9.91341 6.61 8.60674 7.91667 6.99674 7.91667ZM6.99674 3.25C6.02841 3.25 5.24674 4.03167 5.24674 5C5.24674 5.96833 6.02841 6.75 6.99674 6.75C7.96508 6.75 8.74674 5.96833 8.74674 5C8.74674 4.03167 7.96508 3.25 6.99674 3.25Z'
        fill={color || theme.colors.gray800}
      />
    </svg>
  );
}
